import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import DriveService from "../../../../services/drive-service";
import { isSeriesOvertime } from "../../utils/overtime-utils";

/**
 * Hands the ball to the other team after an overtime score that no kickoff
 * follows (PSTATS-1381). A child of ScoreEndedPossession; runs before
 * ResetField, which then spots the ball at the overtime yardline for the new
 * team and awards the first down. Yields when a kickoff is armed (an
 * overtime try, PSTATS-1122) and when a CFL crew foregoes the kickoff, since
 * SkipKickoff hands over at the entered spot. Series overtime only: with OT
 * Kickoffs on the score is followed by a kickoff, as in regulation
 * (PSTATS-1268).
 */
export default class OvertimePossessionSwitch extends Rule {
    applicable(gameContext, ruleContext, eventConfiguration, { play }) {
        return (
            isSeriesOvertime(gameContext) &&
            !gameContext.triggerKO &&
            !play.historyContains(FootballState.SkipKickoff)
        );
    }

    async apply(gameContext, ruleContext, eventConfiguration, { play }) {
        // A field goal's drive is already closed by EndDrive (no-op here); a
        // safety's is still open and ends where the ball died.
        await DriveService.endDrive(gameContext, {
            endSpot: play.getEndFieldPosition()
        });
        gameContext.switchPossession();
        gameContext.setDriveContext({ triggerDrive: true });
        gameContext.currentDriveId = null;
    }
}
